<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    /** @type {'row'|'col'} */
    export let scope = "col";
    /** @type {boolean} */
    export let sortable = false;
    /** @type {'ascending'|'descending'|null} */
    export let sortDirection = null;
    /** @type {'default'|'minimum'} */
    export let size = 'default';
    /** @type {string} */
    export let text = '';

    let sizeClass = size === "minimum" ? "prom-table__header-cell--minimum-size" : "";

    function onSort(event) {
        const table = event.target.closest("table");
        const sortableHeaders = table.querySelectorAll(".prom-table__header-cell:has(.prom-table__header-cell--sortable)");
        
        sortableHeaders.forEach(header => {
            const headerButton = header.querySelector(".prom-table__header-cell--sortable");
            if (event.currentTarget.parentElement === header) {
                if (!header.ariaSort || header.ariaSort === "descending") {
                    header.ariaSort = "ascending";
                }
                else if (header.ariaSort === "ascending") {
                    header.ariaSort = "descending";
                }
                sortDirection = header.ariaSort;
                headerButton.ariaPressed = "true";
            } else {
                header.ariaSort = null;
                headerButton.ariaPressed = undefined;
            }
        });

        dispatch("sort", {
            sortDirection,
            target: event.currentTarget.parentElement
        });
    }
</script>

<th class="prom-table__header-cell {sizeClass}" {scope} aria-sort={sortDirection}>
    {#if sortable}
        <button
            class="prom-table__header-cell--text prom-table__header-cell--sortable" 
            on:click={(event) => onSort(event)}
        >
            <span class="prom-table__header-cell--sortable-text">{text}</span>
        </button>
    {:else}
        <span class="prom-table__header-cell--text">
            {text}
        </span>
    {/if}
</th>
